import ErrorNotification from '../ErrorNotification';

const InputField = ({ id, name, type, label, placeholder, value, error, onChange }) => {
  return (
    <>
      <label htmlFor={id}>{label}</label>
      <input
        type={type}
        id={id}
        name={name}
        className={error && value === "" ? "border-danger" : "border-none"}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      {error && <ErrorNotification message={error} className="text-secondary" />}
    </>
  );
};

export default InputField;